export enum DetailPanelType {
  None,
  Product,
  Material,
}
